import { render, staticRenderFns } from "./PaymentAmount.vue?vue&type=template&id=3c7b24ec&scoped=true&"
import script from "./PaymentAmount.vue?vue&type=script&lang=js&"
export * from "./PaymentAmount.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAmount.vue?vue&type=style&index=0&id=3c7b24ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b24ec",
  null
  
)

export default component.exports
import {QRadio,QInput,QIcon,QCheckbox,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QRadio,QInput,QIcon,QCheckbox,QBtn})
